import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { BusinessDetailsTableActionComponent } from 'ml-capability-quoteandbind-common-react';

import metadata from './MLBusinessActivitiesListPopup.metadata.json5';

import React from 'react';

const MLBusinessActivitiesListPopup = (props) => {
    const {
        submissionVM,
        editBusActivity,
        removeBusActivity,
        onCancel,
        viewModelService
    } = props;
    const overrides = {
        bizActivitiesTableComponent: {
            submissionVM,
            hideAdd: true,
            onEdit: editBusActivity,
            onRemove: removeBusActivity,
            onCancel,
            viewModelService
        }
    };

    const resolvers = {
        resolveComponentMap: {
            businessDetailsTableActionComponent: BusinessDetailsTableActionComponent
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );

};

MLBusinessActivitiesListPopup.propTypes = {
    submissionVM: PropTypes.object,
    editBusActivity: PropTypes.func,
    removeBusActivity: PropTypes.func,
    onCancel: PropTypes.func
};

export default MLBusinessActivitiesListPopup;
